import { SET_ORGANIZATION, RESET_ORGANIZATION } from "./actionConstants";

export const setOrganizationAction = organization => ({
	type: SET_ORGANIZATION,
	data: organization
});

export const resetOrganizationAction = () => ({
	type: RESET_ORGANIZATION
});
